import React from 'react';
import InputControl from '~/components/Input/InputControl';
import InputSelectAsync from '~/components/Input/InputSelectAsync';

import fetchAllExamsIds from '~/utils/fetchAllExamsIds';
import fetchAllMedicationsIds from '~/utils/fetchAllMedicationsIds';
import fetchAllCidIds from '~/utils/fetchAllCidIds';
import fetchAllExitCodeIds from '~/utils/fetchAllExitCodeIds';

function InputMultiIds({ type, stateExternal, setStateExternal, setStateId }) {

  const fetchType = async (input, page, resolve) => {
    switch (type) {
      case 'exam':
        return fetchAllExamsIds(input, page, resolve);
      case 'medication':
        return fetchAllMedicationsIds(input, page, resolve);
      case 'cid':
        return fetchAllCidIds(input, page, resolve);
      case 'cidsec':
        return fetchAllCidIds(input, page, resolve);
      case 'exitCode':
        return fetchAllExitCodeIds(input, page, resolve);
      default:
        return [];
    }
  };

  const clearDuplicates = (arr) => {
    return arr.reduce((acc, curr) => {
      if (!acc.find((e) => e.name === curr.name)) {
        acc.push(curr);
      }
      return acc;
    }, []);
  };

  const handleChange = (event) => {
    switch (type) {
      case 'exam':
        if (!event.exam) {
          return setStateExternal([]);
        } else {
          const exams = clearDuplicates(event.exam);
          setStateId(exams.map((e) => e.id));
          return setStateExternal(exams.map((e) => e));
        }
      case 'medication':
        if (!event.medication) {
          return setStateExternal([]);
        } else {
          const medications = clearDuplicates(event.medication);
          setStateId(medications.map((e) => e.id));
          return setStateExternal(medications.map((e) => e));
        }
      case 'cid':
        if (!event.cid) {
          return setStateExternal([]);
        } else {
          const cids = clearDuplicates(event.cid);
          if (cids.length > 1) {
            cids.shift()
          }
          setStateId(cids.map((e) => e.id));
          return setStateExternal(cids.map((e) => e));
        }
      case 'cidsec':
        if (!event.cidsec) {
          return setStateExternal([]);
        } else {
          const cids = clearDuplicates(event.cidsec);
          if (cids.length > 1) {
            cids.shift();
          }
          setStateId(cids.map((e) => e.id));
          return setStateExternal(cids.map((e) => e));
        }
      case 'exitCode':
        if (!event.exitCode) {
          return setStateExternal([]);
        } else {
          const exits = clearDuplicates(event.exitCode);
          if (exits.length > 1) {
            exits.shift();
          }
          setStateId(exits.map((e) => e.id));
          return setStateExternal(exits.map((e) => e));
        }
      default:
        return [];
    }
  };
  
  return (
    <InputControl
      name={type}
      label={''}
      value={stateExternal}
      inputComponent={InputSelectAsync}
      onChange={handleChange}
      InputProps={{
        isClearable: false,
        handleFetch: fetchType,
        createEnabled: false,
        error: false,
        isMulti: true
      }}
    />
  );
}

export default InputMultiIds;
